import FilterModal, { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";

export const fields: FilterFieldConfig[] = [
    { key: "vendorName", label: "Vendor Name", type: "text", default: "" },
    { key: "website", label: "Website", type: "text", default: "", transform: v => v.toLowerCase() },
    { key: "phoneNumber", label: "Business Number", type: "text", default: "" },
    { key: "extension", label: "Extension", type: "text", default: "" },
    { key: "fax", label: "Fax", type: "text", default: "" },
    { key: "address", label: "Address", type: "text", default: "" },
    { key: "country", label: "Country", type: "text", default: "" },
    { key: "background", label: "Background", type: "text", default: "" },
    {
        key: "creatorId",
        label: "Created By",
        type: "asyncSelect",
        default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    {
        key: "updaterId",
        label: "Updated By",
        type: "asyncSelect",
        default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    {
        key: "void",
        label: "Validity",
        type: "select",
        default: "no",
        options: [
            { value: "no", label: "Valid" },
            { value: "yes", label: "Void" },
            { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function VendorFilterForm() {
    return <FilterModal title = "Filter" width = {650} fields = {fields} />;
}
